import React from 'react';
import BluetoothAutomationTrainer from './BluetoothAutomationTrainer';

const outputLabel = (type) => String(type || 'unknown').replace(/_/g, ' ');

function BluetoothAudioPanel({ device, snapshot, status, onRefresh, settingsStatus, settingsMessage, onOpenSettings, areaId, topology, onTopologyChange }) {
  const bluetooth = snapshot?.bluetooth;
  const a2dpDevices = Array.isArray(bluetooth?.a2dp?.connectedDevices) ? bluetooth.a2dp.connectedDevices : [];
  const bondedDevices = Array.isArray(bluetooth?.bondedDevices) ? bluetooth.bondedDevices : [];
  const outputs = Array.isArray(snapshot?.audioOutputs?.devices) ? snapshot.audioOutputs.devices : [];

  return (
    <section className="bluetooth-audio-panel" aria-live="polite">
      <div className="bluetooth-audio-panel__heading">
        <div>
          <span>Android Bluetooth and audio APIs</span>
          <h3>Audio route telemetry</h3>
          <p>{device ? `Selected device: ${device.name || `Device ${device.id}`}` : 'Select an Android TV or player to inspect its audio connections.'}</p>
        </div>
        <div className="bluetooth-audio-panel__actions">
          <button type="button" onClick={onOpenSettings} disabled={!device || settingsStatus === 'loading'}>
            {settingsStatus === 'loading' ? 'Opening…' : 'Open Bluetooth settings'}
          </button>
          <button type="button" onClick={onRefresh} disabled={!device || status === 'loading'}>
            {status === 'loading' ? 'Retrieving…' : 'Retrieve audio state'}
          </button>
        </div>
      </div>

      {settingsMessage && <p className={`bluetooth-audio-panel__settings-result is-${settingsStatus}`}>{settingsMessage}</p>}

      {!snapshot ? (
        <p className="bluetooth-audio-panel__empty">No Bluetooth/audio report has been received from this device.</p>
      ) : (
        <>
          <div className="bluetooth-audio-panel__summary">
            <div><span>Bluetooth</span><strong>{!bluetooth?.supported ? 'Unsupported' : bluetooth.permissionGranted === false ? 'Permission required' : bluetooth.enabled ? 'Enabled' : 'Disabled'}</strong></div>
            <div><span>Paired</span><strong>{bondedDevices.length}</strong></div>
            <div><span>A2DP connected</span><strong>{a2dpDevices.length}</strong></div>
            <div><span>Outputs present</span><strong>{outputs.length}</strong></div>
          </div>
          {bluetooth?.permissionGranted === false && <p className="bluetooth-audio-panel__warning">Grant Nearby devices/Bluetooth permission on this Android device to report paired and connected devices.</p>}
          <div className="bluetooth-audio-panel__grid">
            <div>
              <h4>Paired Bluetooth devices</h4>
              {bondedDevices.length ? bondedDevices.map((entry) => {
                const connected = a2dpDevices.some((candidate) => candidate.address && candidate.address === entry.address);
                return <div className={`bluetooth-audio-panel__device ${connected ? 'is-connected' : ''}`} key={entry.address || entry.name}><strong>{entry.name}</strong><span>{connected ? 'A2DP connected' : entry.bondState || 'paired'}</span></div>;
              }) : <p className="bluetooth-audio-panel__empty">No paired devices reported.</p>}
            </div>
            <div>
              <h4>Available audio outputs</h4>
              {outputs.length ? outputs.map((output) => <div className="bluetooth-audio-panel__device" key={`${output.id}-${output.type}`}><strong>{output.name || outputLabel(output.type)}</strong><span>{outputLabel(output.type)}</span></div>) : <p className="bluetooth-audio-panel__empty">No output devices reported.</p>}
            </div>
          </div>
          <p className="bluetooth-audio-panel__limitation">Connected A2DP is strong Bluetooth evidence. An available output alone does not prove that media is currently routed through it.</p>
        </>
      )}
      <BluetoothAutomationTrainer areaId={areaId} device={device} snapshot={snapshot} topology={topology} onTopologyChange={onTopologyChange} onOpenSettings={onOpenSettings} />
    </section>
  );
}

export default BluetoothAudioPanel;
